import PopupState, { bindHover, bindPopover } from "material-ui-popup-state";
import HoverPopover from "material-ui-popup-state/HoverPopover";
import React, {useState, useEffect} from "react";
import amplitude from "../../utils/ampli";
import { FaLock, FaLockOpen, FaSpinner  } from "react-icons/fa";
import { GoClockFill } from "react-icons/go";
import axios from "axios";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { apiSlice, useGetFilteredDataMutation } from "../../redux/slices/apiSlice";
import { setSeverity, setAlertText, setToast } from "../../redux/slices/commonComponentSlice";
import { pricing } from "../../redux/slices/pricingSlice";
import { auth } from "../../redux/slices/authSlice";
import { convertToJsonObject, mapping } from "../../utils/utils";
import { Calendar, TrendingDown, X } from "lucide-react/dist/cjs/lucide-react";
import { formatDate } from "../../utils/utils";
 
const AutoHoverClock = ({ isAutoPrice, daysLeft, intervalLeft, revisionPrice, itemId, certNum, target, autoType}) => {
  const dispatch = useDispatch();
  const sorting = useSelector(pricing).sorting;
  const page = useSelector(pricing).page;
  const pageSize = useSelector(pricing).pageSize;
  const filters = useSelector(pricing).filtered;
  const searchParam = useSelector(pricing).searchParam;
  const activeTab = useSelector(pricing).activeTab;
  const accountId = useSelector(auth)?.userDetails?.account_id;
  const [refetchFiltered] = useGetFilteredDataMutation();
  const customFiltersRaw = useSelector(pricing)?.config?.custom_filters ?? [];
  const [isLoading, setIsLoading] = useState(false);


  const renderIcon = () => {
    if (isLoading) {
      return <FaSpinner />;
    } else if(isAutoPrice){
      return <GoClockFill />;
    } 
  };
const stopAutoReprice = async () => {
  setIsLoading(true);

  const url = `${process.env.REACT_APP_API_URL}/pcp_bulk_auto_repricing`;
  const data = {
    item_ids: [itemId],
    select_all: false,
    cert_stock_number: certNum,
    stop_auto_pricings: true,
  };

  const token = Cookies.get("access_token");
  if (!token) {
    setIsLoading(false);
    dispatch(setToast(true));
    dispatch(setAlertText("Not authenticated. Please sign in again."));
    dispatch(setSeverity("error"));
    return;
  }

  try {
    const response = await axios.post(url, data, {
      headers: { Authorization: `Bearer ${token}` },
    });

    // success
    if (Array.isArray(filters) && filters.length > 0 && accountId) {
      try {
        const args = {
          id: accountId,
          from: page ? pageSize * page : 0,
          size: pageSize,
          asc_desc: sorting?.[0]?.asc_desc ?? 'asc',
          sort_by: sorting?.[0]?.sort_by ?? 'sell_offer_cents',
          search: searchParam,
          sort: sorting,
          state: activeTab === 3 ? 'repriced' : '',
          is_filter_locked: activeTab === 1 ? false : activeTab === 2 ? true : '',
          isSearched: false,
        };
        const body = convertToJsonObject(filters, customFiltersRaw);
        const payload = await refetchFiltered({ args, body }).unwrap();
        dispatch({ type: 'pricing/setUserTable', payload: payload?.data?.map((it) => mapping(it)) || [] });
        dispatch({ type: 'pricing/setPageCount', payload: payload?.total_matching_count || 0 });
      } catch (e) {
        dispatch(apiSlice.util.invalidateTags(["priceTable"]));
      }
    } else {
      dispatch(apiSlice.util.invalidateTags(["priceTable"]));
    }
    dispatch(apiSlice.util.invalidateTags([`Rapnet matching ${itemId}`]));

    const message = response?.data?.message ?? "Repricing completed.";
    dispatch(setToast(true));
    dispatch(setAlertText(message));
    dispatch(setSeverity("success"));

  } catch (err) {
    const message =
      err?.response?.data?.message ||
      err?.message ||
      "Something went wrong while repricing.";
    dispatch(setToast(true));
    dispatch(setAlertText(message));
    dispatch(setSeverity("error"));
  } finally {
    setIsLoading(false);
  }
};

  return (
    <>
      <PopupState variant="popover" popupId="comment-popover">
        {(popupState) => (
          <div>
            <div {...bindHover(popupState)}>
              {renderIcon()}
            </div>
            <HoverPopover
              {...bindPopover(popupState)}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
            >
              {/* Content */}
              <div className={`w-72 p-4 space-y-3 ${isAutoPrice ? "bg-white" : ""}`}>
                {/* Header */}
                <div className="flex flex-col items-start gap-1">
                  <div className="flex justify-between items-center w-full">
                    <h4 className="font-semibold text-sm mb-1">Auto Pricing</h4>
                    <div className="flex gap-1 items-start">
                   <p className="inline-flex items-center rounded-md border border-blue-200 bg-blue-50 px-2 py-0.5 text-[0.64rem] text-blue-700">
                    <GoClockFill className="h-[0.7rem] w-[0.7rem]  mr-1 text-blue-500" />
                    Active
                  </p>
                  <p className="flex justify-center w-full items-center rounded-md border border-green-200 bg-green-50 px-2 py-0.5 text-[0.64rem] text-green-700">
                    {autoType == "rap_discount" ? "Rap Disc" : autoType == "total_price" ? "Total Price" : "PPC"}
                  </p>
                  </div>
                  </div>
                    <p className="text-xs text-muted-foreground">Automated price adjustments in progress</p>
                  
                  
                </div>
                <hr className="border-t border-gray-600 " />

                {/* Details */}
                <div className="space-y-1 flex flex-col   text-xs">
                  <div className="flex justify-between items-center py-2 border-b">
                    <p className="text-muted-foreground">Next Change</p>
                    <p className="font-medium flex items-center gap-1">
                      <TrendingDown className="h-3 w-3 text-blue-500" />
                      {autoType == "rap_discount" ? `${revisionPrice}%` : revisionPrice < 0
                        ? `-$${Math.abs(revisionPrice).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 1 })}`
                        : `+$${Number(revisionPrice ?? 0).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 1 })}`}
                      </p>  
                  </div>

                  <div className="flex justify-between items-center py-2 border-b">
                    <p className="text-muted-foreground">Next Change In</p>
                    <p className="font-medium flex items-center gap-1">
                      <Calendar className="h-3 w-3" />
                      {daysLeft} days
                    </p>
                  </div>

                  {target !== undefined && target !== null && (
                    <div className="flex justify-between items-center py-2">
                      <p className="text-muted-foreground">Target Price</p>
                      <p className="font-semibold text-green-600">
                      {autoType == "rap_discount" ? `${target}%` : target < 0
                        ? `-$${Math.abs(target).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 1 })}`
                        : `+$${Number(target ?? 0).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 1 })}`}
                      </p>
                    </div>
                  )}

                  <div className="flex justify-between items-center py-2">
                    <p className="text-muted-foreground">Steps Remaining</p>
                    <p className="text-[0.69rem] px-2 border border-gray-300 rounded-md text-center text-black">
                      {intervalLeft ? intervalLeft : "-"} changes
                    </p>
                  </div>
                </div>
                {/* Action */}
                <div className="pt-2 border-t">
                  <div
                    className="flex w-full justify-center gap-2 items-center font-semibold border border-red-200 rounded-md px-3 py-1 cursor-pointer text-xs bg-red-50 text-red-700 hover:bg-red-100"
                    onClick={(ev) => {
                      try {
                        const buttonClickedEvent = {
                          event_type: `v4_cancel_autoreprice`,
                          event_properties: {},
                        };
                        amplitude.track(buttonClickedEvent);
                      } catch {}
                      stopAutoReprice();
                      ev.stopPropagation();
                    }}
                  >
                    <X className="h-3.5 w-3.5" />
                    Cancel Auto Pricing
                  </div>
                </div>
              </div>
            </HoverPopover>
          </div>
        )}
      </PopupState>
    </>
  );
};

export default AutoHoverClock;
